






































































































































































import _ from 'lodash'
import Component, {mixins} from 'vue-class-component'
import {Getter, State} from 'vuex-class'
import AppRelease from '@/modules/app-router/model/AppRelease'
import AppReleaseDetail from '@/modules/app-router/components/AppRelease/AppReleaseDetail.vue'
import App from '@/modules/app-router/model/App'
import {DateMixin} from '@/modules/core/date'
import AppReleaseListItem from '@/modules/app-router/components/AppRelease/AppReleaseListItem.vue'
import DeleteReservationConfirm from '@/modules/reservation/components/DeleteReservationConfirm.vue'
import ConfirmDeleteRelease from '@/modules/app-router/components/AppRelease/ConfirmDeleteRelease.vue'
import FileButton from '@/components/FileButton.vue';
import {Ref} from 'vue-property-decorator';

/**
 * Muestra al usuario la lista de publicaciones de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {FileButton, ConfirmDeleteRelease, DeleteReservationConfirm, AppReleaseListItem, AppReleaseDetail},
})
export default class AppReleaseList extends mixins(DateMixin) {
    /**
     * Aplicación actualmente seleccionada por el usuario
     */
    @State(state => state.appRouter.app)
    public app: App

    @Ref('fileInput')
    public fileSelector: HTMLInputElement

    @Getter('appRouter/releases')
    public releases: AppRelease[]

    public releaseDetail = false
    public appMenu = false

    public confirmDelete = false

    public reloading = false
    public searchDialog = false
    public search = ''

    /**
     * Crea una nueva distribución a partir de un fichero ZIP
     */
    public createReleaseFromFile (files: FileList) {
        const file = files.item(0)
        if (!file) {
            return
        }

        const release = new AppRelease()
        release.distFile = file

        this.editRelease(release)

        // Reseta el valor del input para poder volver a seleccionar el mismo archivo de nuevo.
        this.fileSelector.value = ''
    }

    public get appIsSelected () {
        return !this.$store.state.appRouter.app.isNew
    }

    public get displayDisabledReleases (): boolean {
        return this.$store.state.appRouter.displayDisabledReleases
    }

    public set displayDisabledReleases (value: boolean) {
        this.$store.commit('appRouter/TOGGLE_DISPLAY_DISABLED_RELEASES', value)
    }

    public get displayDefaultRelease (): boolean {
        return this.$store.state.appRouter.displayDefaultRelease
    }

    public set displayDefaultRelease (display: boolean) {
        this.$store.commit('appRouter/TOGGLE_DISPLAY_DEFAULT_RELEASE', display)
    }

    public displayMode = 0

    public deleteRelease (release: AppRelease) {
        this.$store.commit('appRouter/SET_CURRENT_APP_RELEASE', release)
        this.confirmDelete = true
    }

    /**
     * Solicita a la aplicación la creación de una nueva distribución de la
     * aplicación
     */
    public async editRelease (release?: AppRelease) {
        await this.$store.dispatch('appRouter/loadAppRelease', release)
        this.releaseDetail = true
    }

    /**
     * Recarga la lista de aplicaciones registradas en el enrutador
     */
    public async reload () {
        this.reloading = true
        await this.$store.dispatch('appRouter/loadApps')

        this.reloading = false
    }

    /**
     * Indica si se encuentra activa la pantalla de version para grupos
     */
    public get screenIsActive () {
        return this.$route.name === 'app-router' && !this.releaseDetail && !this.$store.state.appRouter.apiVersionDetail
    }
}
